export const setToLocalStorage = (key, value) => {
    if (typeof key !== "string" || key === '') {
        throw new Error('Invalid key: must be a non-empty string');
    }
    try {
        const stringValue = JSON.stringify(value);
        localStorage.setItem(key, stringValue);
        return true; // Successfully set in localStorage
    } catch (err) {
        // Check for quota error by multiple possible conditions
        if (
            (err instanceof DOMException && 
                (err.name === 'QuotaExceededError' || err.code === 22)) ||
            err.message?.includes('quota') || 
            err.message?.includes('exceed')
        ) {
            console.error('Local storage is full or quota exceeded.');
        } else {
            console.error(`Error setting value "${value}" in key "${key}": ${err.message}`);
        }
        return false; // Indicate failure
    }
};

export const removeFromLocalStorage = (key) => {
    if (typeof key !== "string" || key === '') {
        throw new Error('Invalid key: must be a non-empty string');
    }
    try {
        localStorage.removeItem(key);
        return true; // Return true to indicate success
    } catch (err) {
        console.error(`Error removing "${key}": ${err.message}`);
        return false; // Return false to indicate failure
    }
};

export const clearLocalStorage = () => {
    try {
        localStorage.clear();
        return true; // Return true to indicate success
    } catch (err) {
        console.error(`Error clearing localStorage ${err.message}`);
        return false; // Return false to indicate failure
    }
}